import React from 'react';
import { ArrowRight, Phone, Shield, Clock, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { trackEvent } from '../lib/analytics';

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const onGetQuote = () => {
    trackEvent('click_get_quote_button', { location: 'hero' });
    scrollTo('quote');
  };

  const onCallNow = () => {
    trackEvent('click_call_button', { location: 'hero', number: '+610487698671' });
    window.location.href = 'tel:+610487698671';
  };

  return (
    <section
      id="hero"
      className="relative pt-32 sm:pt-36 pb-10 px-4 sm:px-6 lg:px-8 overflow-hidden"
    >
      {/* Background image (pre-optimized, pre-blurred) */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/hero-bg.webp')",
        }}
        aria-hidden="true"
      />
      {/* White/brand overlay for readability */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-white/85 via-slate-50/80 to-blue-50/85"
        aria-hidden="true"
      />

      <div className="relative max-w-5xl mx-auto text-center space-y-6">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF8C42]/10 rounded-full">
          <span className="text-[#FF8C42] font-semibold text-sm">
            Sydney's Trusted Moving Service
          </span>
        </div>

        {/* H1 */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1E3A5F] leading-tight">
          <span className="mr-2" role="img" aria-label="moving truck">🚚</span>
          Sydney Removalists
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
          Fast, Reliable &amp; Affordable Moving Services
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button
            size="lg"
            data-testid="hero-get-quote"
            className="bg-[#FF8C42] hover:bg-[#e67a35] text-white text-base px-8 py-6"
            onClick={onGetQuote}
          >
            Get Free Quote
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            data-testid="hero-call-now"
            className="border-2 border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-white text-base px-8 py-6"
            onClick={onCallNow}
          >
            <Phone className="mr-2 w-5 h-5" />
            Call Now!
          </Button>
        </div>

        {/* Trust strip */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 pt-4 text-sm font-medium text-gray-700">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-[#FF8C42]" />
            Fully Insured
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-[#FF8C42]" />
            Same Day Available
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-[#FF8C42]" />
            No Hidden Fees
          </div>
        </div>
      </div>
    </section>
  );
};
